import { createSlice } from "@reduxjs/toolkit"
import {
  addAllergen,
  deleteAllergen,
  getAllergenDetails,
  getAllergens,
  getAllergensList,
  updateAllergen,
  updateAllergenStatus,
} from "store/actions/allergensAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  allergensList: [],
  allergens: [],
  allergenDetails: {},
}

const usersSlice = createSlice({
  name: "allergens",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL ALLERGENS
    builder
      .addCase(getAllergens.pending, state => {
        state.loading = true
      })
      .addCase(getAllergens.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.allergens = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllergens.rejected, (state, action) => {
        state.loading = false
      })

    // GET ALL ALLERGENS LIST
    builder
      .addCase(getAllergensList.pending, state => {
        state.loading = true
      })
      .addCase(getAllergensList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.allergensList = data
        }
      })
      .addCase(getAllergensList.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE INGREDIENTS STATUS
    builder
      .addCase(updateAllergenStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateAllergenStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.allergens = state.allergens.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateAllergenStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE ALLERGEN
    builder
      .addCase(deleteAllergen.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteAllergen.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.allergens = state.allergens.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteAllergen.rejected, (state, action) => {
        state.isLoading = false
      })

    //  ADD ALLERGEN
    builder
      .addCase(addAllergen.pending, state => {
        state.isLoading = true
      })
      .addCase(addAllergen.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addAllergen.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPDATE ALLERGEN
    builder
      .addCase(updateAllergen.pending, state => {
        state.isLoading = true
      })
      .addCase(updateAllergen.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateAllergen.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET ALLERGEN DETAILS
    builder
      .addCase(getAllergenDetails.pending, state => {
        state.loading = true
        state.allergenDetails = {}
      })
      .addCase(getAllergenDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        // console.log(data)
        if (status) {
          state.allergenDetails = data
        }
      })
      .addCase(getAllergenDetails.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default usersSlice.reducer
